import React from 'react';

import { TrackingContext } from '../hooks/useTracking/useTracking';
import type { NavigationDrilldownProps } from '../types';
import { NavigationDrilldownDrawer } from './NavigationDrilldownDrawer';

export const NavigationDrilldown = ({ navigation, onClose }: NavigationDrilldownProps) => (
  <TrackingContext.Provider value={{ navigationData: navigation }}>
    <NavigationDrilldownDrawer navigation={navigation} onClose={onClose} />
  </TrackingContext.Provider>
);
